import { Markup } from "interweave";
import React from "react";
import { useContext } from "react";
import { Button, Spinner } from "react-bootstrap";
import ReactPlayer from "react-player";
import { Link } from "react-router-dom";
import noImage from "../../.../../../../../../assets/images/settings/no-image.png";
import PriceTag from "../../.../../../../../../assets/images/tagPrice.PNG";
import { serverInfo } from "../../../../../../App";

const DetailsSouvenir = ({ souviner }) => {
  const { imageCdnUrl } = useContext(serverInfo);

  return (
    <>
      <div className="m-3">
        <div className="row ">
          <div className="col-md-12">
            <div className="card card-bg p-2">
              <img
                src={souviner?.banner ? imageCdnUrl + souviner?.banner : noImage}
                alt=""
                className=" img-fluid"
                style={{ maxHeight: 400 }}
              />
            </div>
          </div>
          
        </div>

        <div className="mt-3 row">
          <div className="col-md-12 ">
            {/* <div className="card card-bg px-3 py-4">
              <h4 className="text-light">{souviner?.title}</h4>
            </div>
            <div className="card card-bg px-3 py-4">
              <h5 className="text-warning">Description</h5>
              <p className="text-light pt-1">
                <Markup content={souviner?.description} />
              </p>
            </div>
            <div className="card card-bg px-3 py-4 mt-2">
              <h5 className="text-warning">Instruction</h5>
              <p className="text-light pt-1">
                <Markup content={souviner?.instruction} />
              </p>
            </div> */}
            <div className=" px-3 py-4">
              <div className="card head-line">
                <div className="text-light d-flex justify-content-center p-2 suvenir-bg">
                  <div className="faTrophy">
                    <i className="fas fa-trophy"></i>
                  </div>
                  <h4 className="mx-3 text-white p-2">{souviner?.title}</h4>
                </div>
              </div>
            </div>

            <div className="card card-bg mt-4">
              <div className="card-body">
                <h5 className="text-warning">Instruction</h5>
                <div className="under-line"></div>
                <p className="text-light mt-2">
                  <Markup content={souviner?.instruction} />
                </p>

                <h5 className="text-warning">Description</h5>
                <div className="under-line"></div>
                <p className="text-light mt-2">
                  <Markup content={souviner?.description} />
                </p>

                <div className="row">
                  <div className="col-md-6  "></div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-4 mx-auto mb-2">
                <div
                  className="d-flex justify-content-center border border-warning bg-dark mt-3 p-2 buTon-a "
                  style={{ width: "100%" }}
                >
                  <span>
                    <img src={PriceTag} alt="" className="PriceTage" />
                  </span>
                  <div className=" mx-2 ">
                    <span className="text-light buTon-ab ">Cost</span>
                    <br></br>
                    <span className="text-info fw-bold buTon-abc">
                      {souviner?.price} $
                    </span>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="col-md-2 d-flex bg-dark mt-3 p-2 buTon-a ">
              <span>
                <img src={PriceTag} alt="" className="PriceTage" />
              </span>
              <div className=" mx-2 ">
                <span className="text-light buTon-ab ">Cost</span>
                <br></br>
                <span className="text-light buTon-abc">
                  {souviner?.price} $
                </span>
              </div>
            </div> */}
            <div className=" mb-3">
              <div className="row mt-4">
                {/* <button className="btn bg-success text-light w-100 py-2 me-3 fw-bold">
                                            <Spinner animation="border" Waiting For Approval  />
                                            </button> */}
                <div className="col-md-7 row mx-auto">
                  {Number(souviner?.status) === 0 ? (
                    <div className="col-md-4 mx-auto mb-2">
                      <Button
                        variant="primary"
                        disabled
                        className="btn btnSave w-100 text-dark py-2 me-3 fw-bold"
                      >
                        {/* <Spinner as="span" animation="border" /> */}
                        <i className="fas fa-spinner fa-pulse"></i>
                        <span className="pb-3 mx-1">Waiting</span>
                      </Button>
                    </div>
                  ) : (
                    <div className="col-md-4 mx-auto mb-2">
                      <Button
                        variant="primary"
                        disabled
                        className="btn btnConfirm w-100 text-light py-2 me-3 fw-bold"
                      >
                        <i className="fa fa-check"></i> Approved
                      </Button>
                    </div>
                  )}

                  {Number(souviner?.approval_status) === 0 ? (
                    <div className="col-md-4 mx-auto mb-2">
                      <Link
                        to={`/superstar-admin/souvenir/edit/${souviner?.id}`}
                      >
                        <button className="btn btnUpdate w-100 text-dark py-2  fw-bold">
                          Edit <i className="fa fa-edit"></i>
                        </button>
                      </Link>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DetailsSouvenir;
